import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import './PaymentSuccess.css';


import { API } from '../config';

export default function SubscriptionSuccess({ user }) {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      pollSubscriptionStatus(sessionId, 0);
    }
  }, [sessionId]);

  const pollSubscriptionStatus = async (sessionId, attempts) => {
    const maxAttempts = 5;
    const pollInterval = 2000;

    if (attempts >= maxAttempts) {
      setStatus('timeout');
      return;
    }

    try {
      const response = await axios.get(`${API}/subscriptions/checkout/status/${sessionId}`);
      
      if (response.data.payment_status === 'paid') {
        setStatus('success');
        setSubscriptionInfo(response.data);
        toast.success('Subscription activated!');
      } else if (response.data.status === 'expired') {
        setStatus('failed');
      } else {
        setTimeout(() => pollSubscriptionStatus(sessionId, attempts + 1), pollInterval);
      }
    } catch (error) {
      setStatus('failed');
    }
  };

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="payment-success-page" data-testid="subscription-success-page">
      <div className="payment-success-container">
        <div className="payment-success-card card">
          {status === 'checking' && (
            <>
              <div className="payment-icon">⏳</div>
              <h1>Processing Subscription...</h1>
              <p>Please wait while we activate your subscription.</p>
              <div className="spinner"></div>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="payment-icon success">✅</div>
              <h1>Subscription Activated!</h1>
              <p>Your group subscription has been successfully activated.</p>
              {subscriptionInfo && (
                <div className="payment-details">
                  <div className="detail-item">
                    <span>Amount Paid:</span>
                    <span className="amount">${subscriptionInfo.amount.toFixed(2)}</span>
                  </div>
                  <div className="detail-item">
                    <span>Status:</span>
                    <span className="status-badge status-approved">Active</span>
                  </div>
                </div>
              )}
              <button 
                onClick={goToDashboard} 
                className="btn btn-primary"
                data-testid="go-to-dashboard-btn"
              >
                Go to Dashboard
              </button>
            </>
          )}

          {status === 'failed' && (
            <>
              <div className="payment-icon failed">❌</div>
              <h1>Subscription Failed</h1>
              <p>We couldn't process your subscription payment. Please try again.</p>
              <button onClick={goToDashboard} className="btn btn-primary">
                Return to Dashboard
              </button>
            </>
          )}

          {status === 'timeout' && (
            <>
              <div className="payment-icon">⚠️</div>
              <h1>Processing...</h1>
              <p>We're still processing your subscription. Please check your dashboard in a few minutes.</p>
              <button onClick={goToDashboard} className="btn btn-primary">
                Go to Dashboard
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
